import { Helmet } from 'react-helmet-async';
import TabsMAIQ from 'app/components/TabsMAIQ';
import { PageContainer, PageHeader } from 'app/components/StyledComponents';
import { BreadcrumbsComponent } from 'app/components/BreadcrumbsComponent';
import DealerSettingsTab from './components/dealerSettings/DealerSettingsTab';
import ValueContentTab from './components/valueContent/ValueContentTab';
import OfferContentTab from './components/offerContent/OfferContentTab';
import FooterImageTab from './components/footerImage/FooterImageTab';
import DealerSpecialsTab from './components/dealerSpecials/DealerSpecialsTab';
import ContentImportExport from './components/ContentImportExport';
import { Box, maxHeight } from '@mui/system';
import { useSelector } from 'react-redux';
import { selectDealerSelected } from 'app/pages/Header/selectors';
import { hasResource } from 'app/components/ReusableUIComponents/HOCs/ResourceProtected/withResourceProtection';

const ContentManagementPage = () => {
  const selectedDealer = useSelector(selectDealerSelected) || {};
  const selectedDealerId = selectedDealer.dealer || '';
  
  // Check if user has access to ImportExportMAIQ resource
  const hasImportExportAccess = hasResource('ImportExportMAIQ');

  const tabsData = [
    {
      label: 'DEALER SETTINGS',
      content: <DealerSettingsTab />,
    },
    {
      label: 'VALUE CONTENT',
      content: <ValueContentTab />,
    },
    {
      label: 'OFFER CONTENT',
      content: <OfferContentTab />,
    },
    {
      label: 'FOOTER IMAGE',
      content: <FooterImageTab />,
    },
    {
      label: 'DEALER SPECIALS',
      content: <DealerSpecialsTab />,
    },
  ];

  const breadcrumbsList = [{ label: 'Content Management', isActive: true }];

  return (
    <>
      <Helmet>
        <title>Content Management</title>
        <meta
          name="description"
          content="Manage Content Engine Settings, Offers, Dealer Values, and Branding Information"
        />
      </Helmet>
      <Box sx={{
        height: 'calc(100vh - 66px)',
        padding: '0 48px',
        display: 'flex',
        flexDirection: 'column'
      }}>
        {/* <PageContainer> */}
          <Box sx={{ marginTop: '48px', marginBottom: '48px', display: 'flex', justifyContent: 'space-between'}}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
              <BreadcrumbsComponent breadcrumbsList={breadcrumbsList} />
              <PageHeader sx={{ marginBottom: '0 !important' }}>Content Management</PageHeader>
            </Box>
            {hasImportExportAccess && <ContentImportExport selectedDealerId={selectedDealerId} />}
          </Box>
          <Box sx={{ flex: 1, overflow: 'hidden' }}>
            <TabsMAIQ key={selectedDealerId} tabs={tabsData} />
          </Box>
        {/* </PageContainer> */}
      </Box>
    </>
  );
};

export default ContentManagementPage;
